function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { getEnvironment, memoize } from '@sail/utils';
import { AnalyticsReporter, DualReporter } from '@stripe-internal/analytics-js';
import { DEFAULT_PARAMETERS_ALLOW_LIST } from '../../internal/analytics/constants';
import { MissingServiceObservabilityError } from '../../internal/common/errors';
import logErrorInDev from '../../internal/common/logErrorInDev';
const DEFAULT_MAX_PAGE_LENGTH = 300;
const LEGACY_ENDPOINT_CONFIG = {
    overrideTrackingUrl: {
        prod: 'https://t.stripe.com/',
        qa: 'https://t.stripe.com/'
    }
};
const createAnalyticsReporter = (config)=>{
    const { service, userId, pageViewToken, parametersAllowList, disableCookies, maxPageLength, cookieEnforcementMode, useLegacyEndpoint } = config;
    if (!service) {
        logErrorInDev(new MissingServiceObservabilityError());
        return null;
    }
    const inProduction = getEnvironment() === 'production';
    const useCookies = disableCookies ? 'disabled' : 'newCookies';
    const safeParams = (parametersAllowList !== null && parametersAllowList !== void 0 ? parametersAllowList : []).concat(DEFAULT_PARAMETERS_ALLOW_LIST).reduce((acc, key)=>{
        acc[key] = true;
        return acc;
    }, {});
    const analyticsJsConfig = {
        clientId: service,
        inProduction,
        safeParams,
        useCookies,
        maxPageLength: maxPageLength !== null && maxPageLength !== void 0 ? maxPageLength : DEFAULT_MAX_PAGE_LENGTH,
        stripeCookiesEnforcementMode: cookieEnforcementMode,
        cookies: {
            user: userId
        },
        pageviewtoken: pageViewToken,
        batchSettings: {
            enableBatching: true
        }
    };
    return useLegacyEndpoint ? new DualReporter(analyticsJsConfig, _object_spread({}, analyticsJsConfig, LEGACY_ENDPOINT_CONFIG), [], // Always send to legacy endpoint
    ()=>true) : new AnalyticsReporter(analyticsJsConfig);
};
export default memoize(createAnalyticsReporter);

//# sourceMappingURL=createAnalyticsReporter.js.map